import React from 'react'
// import { useFormContext } from 'react-hook-form'
import PropTypes from 'prop-types'
import {
  HookTextField,
  HookCheckbox,
  HookCheckboxForStrings,
  HookSelect,
  HookDatePicker,
  HookRadioGroup,
  FileInput,
  HookAutoCompleteLocation,
  TimePicker,
  HookSwitch,
  TimePickerSelection,
  HookRichTextEditor
} from './inputs'

/**
 * @author Miika Rantakaulio
 */
const Field = (props) => {
  return <Input {...props} />
}

const Input = (props) => {
  const { inputType, setValue, watchValue, ...rest } = props

  React.useEffect(() => {
    if (typeof setValue === 'function' && typeof watchValue !== 'undefined') {
      setValue()
    }
  }, [setValue, watchValue])

  switch (inputType ? inputType.toLowerCase() : null) {
    case 'textfield':
      return <HookTextField {...rest} />
    case 'checkbox':
      return <HookCheckbox {...rest} />
    case 'checkbox-for-strings':
      return <HookCheckboxForStrings {...rest} />
    case 'select':
      return <HookSelect {...rest} />
    case 'datepicker':
      return <HookDatePicker {...rest} />
    case 'timepicker':
      return <TimePicker {...rest} />
    case 'timepicker-selection':
      return <TimePickerSelection {...rest} />
    case 'radiogroup':
      return <HookRadioGroup {...rest} />
    case 'file':
      return <FileInput {...rest} />
    case 'autocomplete-places':
      return <HookAutoCompleteLocation {...rest} />
    case 'switch':
      return <HookSwitch {...rest} />
    case 'richtexteditor':
      return <HookRichTextEditor {...rest} />
    default:
      return <span>Error: invalid component type</span>
  }
}

Field.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  inputType: PropTypes.oneOf([
    'textfield',
    'select',
    'checkbox',
    'checkbox-for-strings',
    'datepicker',
    'timepicker',
    'timepicker-selection',
    'radiogroup',
    'file',
    'autocomplete-places',
    'switch',
    'richtexteditor'
  ]).isRequired,
  defaultValue: PropTypes.any,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  type: PropTypes.string,
  setValue: PropTypes.func,
  control: PropTypes.object.isRequired
}

export default Field
